import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, FlexBox, Paragraph, Title } from '@vchasno/ui-kit';

import { t } from 'ttag';
import Icon from 'ui/icon';
import Popup from 'ui/popup/popup';

import LockSvg from './images/lock.svg';

import css from './SessionExpiredPopup.css';

interface SessionExpiredPopupProps {
    isActive: boolean;
    onClose: () => void;
}

const SessionExpiredPopup: React.FC<SessionExpiredPopupProps> = (props) => {
    const history = useHistory();

    const onClick = () => {
        history.push('/auth/check-email');
        props.onClose();
    };

    return (
        <Popup
            hiddenCloseButton
            active={props.isActive}
            onClose={props.onClose}
            className={css.popup}
        >
            <FlexBox direction="column" gap={40} align="center">
                <FlexBox align="center" justify="center" className={css.icon}>
                    <Icon glyph={LockSvg} />
                </FlexBox>
                <FlexBox direction="column" gap={16}>
                    <Title
                        level={2}
                        className={css.title}
                    >{t`Сесія завершилася`}</Title>
                    <Paragraph
                        className={css.mainText}
                    >{t`Сесію завершено через неактивність вашого облікового запису`}</Paragraph>
                </FlexBox>
                <Button onClick={onClick}>{t`Увійти`}</Button>
            </FlexBox>
        </Popup>
    );
};

export default SessionExpiredPopup;
